import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import type { iCustomerPaymentReceipt } from "@sdk/bookings/booking-model";
import React from "react";

const ViewPaymentReceiptModal = React.lazy(
  () => import("./view-payment-receipt-modal"),
);

const ViewPaymentReceipt: iModalProps<
  typeof ViewPaymentReceiptModal,
  {
    bookingId: string;
    receipt: iCustomerPaymentReceipt;
    onSuccess?: () => void;
    accountingContext?: boolean;
  }
> = {
  name: "view-payment-receipt",
  component: GenerateModalWithSuspense(ViewPaymentReceiptModal),
};

export default ViewPaymentReceipt;
